(function () {
  const headerOuter = document.getElementById('header-outer');
  const hamburger = document.querySelector('.site-header__hamburger');
  const nav = document.querySelector('.site-header__nav');

  if (!headerOuter) {
    return;
  }

  window.addEventListener('scroll', function () {
    headerOuter.classList.toggle('is-scrolled', window.scrollY > 50);
  }, { passive: true });

  if (!hamburger || !nav) {
    return;
  }

  hamburger.addEventListener('click', function () {
    const isOpen = nav.classList.toggle('is-open');
    hamburger.setAttribute('aria-expanded', String(isOpen));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) {
      nav.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.focus();
    }
  });
})();
